var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.attachments_menu),function(a){return _c('b-dropdown-item',{key:a.value,attrs:{"aria-role":"listitem"},on:{"click":function($event){return _vm.clicked(a.value)}}},[_vm._v(_vm._s(a.text))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }